<!-- Menu and content layout -->
<div class="settings-container">
    <div *ngIf="!showContentOnSmallScreen || !isSmallScreen" class="settings-menu">
        <mat-list>
            <mat-list-item (click)="selectSection('personal-info')" [class.active]="selectedSection === 'personal-info'">
              <mat-icon>person</mat-icon>
              <span>{{ 'SETTINGS.MENU.ACCOUNT' | translate }}</span>
            </mat-list-item>
            <mat-list-item (click)="selectSection('privacy')" [class.active]="selectedSection === 'privacy'">
              <mat-icon>lock</mat-icon>
              <span>{{ 'SETTINGS.MENU.PRIVACY' | translate }}</span>
            </mat-list-item>
            <mat-list-item (click)="selectSection('language')" [class.active]="selectedSection === 'language'">
              <mat-icon>language</mat-icon>
              <span>{{ 'SETTINGS.MENU.LANGUAGE' | translate }}</span>
            </mat-list-item>
            <mat-list-item (click)="selectSection('content-display')" [class.active]="selectedSection === 'content-display'">
              <mat-icon>visibility</mat-icon>
              <span>{{ 'SETTINGS.MENU.THEME' | translate }}</span>
            </mat-list-item>
            <mat-list-item (click)="selectSection('notifications')" [class.active]="selectedSection === 'notifications'">
              <mat-icon>notifications</mat-icon>
              <span>{{ 'SETTINGS.MENU.NOTIFICATIONS' | translate }}</span>
            </mat-list-item>
            <mat-list-item (click)="selectSection('help')" [class.active]="selectedSection === 'help'">
              <mat-icon>help</mat-icon>
              <span>{{ 'SETTINGS.MENU.HELP' | translate }}</span>
            </mat-list-item>
            <mat-list-item (click)="selectSection('about')" [class.active]="selectedSection === 'about'">
              <mat-icon>info</mat-icon>
              <span>{{ 'SETTINGS.MENU.ABOUT' | translate }}</span>
            </mat-list-item>
        </mat-list>
    </div>
  
    <div *ngIf="showContentOnSmallScreen || !isSmallScreen" class="settings-content">
      <!-- Back button only on small screens -->
      <button *ngIf="isSmallScreen" mat-button (click)="goBackToMenu()" class="back-button">
        <mat-icon>arrow_back</mat-icon> {{ 'SETTINGS.BACK_TO_MENU' | translate }}
      </button>
      
      <!-- Sections de contenu -->
      <app-personal-info *ngIf="selectedSection === 'personal-info'"></app-personal-info>
      <app-privacy *ngIf="selectedSection === 'privacy'"></app-privacy>
      <app-language *ngIf="selectedSection === 'language'"></app-language>
      <app-content-display *ngIf="selectedSection === 'content-display'"></app-content-display>
      <app-notifications *ngIf="selectedSection === 'notifications'"></app-notifications>
      <app-help *ngIf="selectedSection === 'help'"></app-help>
      <app-about *ngIf="selectedSection === 'about'"></app-about>
    </div>
</div>